import { useImportJobPoller } from '@/hooks/useImportJobPoller';

/**
 * Global import job monitor component
 * This component should be mounted at the app root to ensure continuous monitoring
 * of import jobs even when modals are closed
 */
export function ImportJobMonitor() {
  // This hook handles all the polling and notifications
  useImportJobPoller();
  
  // This component doesn't render anything visible
  return null;
}